// Lightweight translation dictionary for the app.
// Structure: translations[language][namespace][key]
// Access via the `t("namespace.key", vars)` helper from LanguageContext.
//
// Greek ("el") is the source language and the default.
// English ("en") is provided per key. Missing English keys fall back to Greek.

const translations = {
  el: {
    common: {
      programShort: "Πρόγραμμα Απόκτησης Διδακτικής Εμπειρίας",
      programLong: "Πρόγραμμα Απόκτησης Ακαδημαϊκής Διδακτικής Εμπειρίας",
      email: "Email",
      password: "Κωδικός πρόσβασης",
      close: "Κλείσιμο",
      clear: "Καθαρισμός",
      back: "Πίσω",
      refresh: "Ανανέωση",
      loading: "Φόρτωση...",
      select: "Επιλέξτε...",
      noOptions: "Δεν υπάρχουν επιλογές",
      showPassword: "Εμφάνιση κωδικού",
      hidePassword: "Απόκρυψη κωδικού",
      info: "Πληροφορίες",
      delete: "Διαγραφή",
      today: "Σήμερα",
      serverUnreachable:
        "Δεν ήταν δυνατή η επικοινωνία με τον διακομιστή. Ελέγξτε τη σύνδεσή σας και δοκιμάστε ξανά.",
    },
    header: {
      title: "ΑΙΤΗΣΗ ΥΠΟΨΗΦΙΟΤΗΤΑΣ ΔΙΔΑΣΚΟΝΤΩΝ ΠΑΝΕΠΙΣΤΗΜΙΟΥ ΠΑΤΡΩΝ {year}",
      subtitle:
        "Πρόσκληση απόκτησης διδακτικής-ακαδημαϊκής εμπειρίας για νέους επιστήμονες, κατόχους διδακτορικού",
      switchToLight: "Αλλάξτε σε φωτεινή λειτουργία",
      switchToDark: "Αλλάξτε σε σκοτεινή λειτουργία",
      login: "Σύνδεση",
      register: "Εγγραφή",
      roleAdmin: "Διαχειριστής",
      roleApplicantMale: "Υποψήφιος",
      roleApplicantFemale: "Υποψήφια",
      roleGuestMale: "Επισκέπτης",
      roleGuestFemale: "Επισκέπτρια",
    },
    login: {
      pageTitle: "Σύνδεση στην εφαρμογή",
      submit: "Σύνδεση",
      noAccount: "Δεν έχετε λογαριασμό; Εγγραφείτε",
      genericError: "Προέκυψε σφάλμα κατά τη σύνδεση. Παρακαλώ δοκιμάστε ξανά.",
      invalidCredentials:
        "Τα στοιχεία σύνδεσης δεν είναι σωστά. Ελέγξτε email και κωδικό και δοκιμάστε ξανά.",
      serverError:
        "Η σύνδεση δεν ήταν δυνατή λόγω τεχνικού προβλήματος. Παρακαλώ δοκιμάστε ξανά σε λίγο.",
    },
    register: {
      pageTitle: "Εγγραφή στην εφαρμογή",
      submit: "Εγγραφή",
      haveAccount: "Έχετε ήδη λογαριασμό; Σύνδεση",
      firstName: "Όνομα",
      lastName: "Επώνυμο",
      nameNote: "Σημείωση για το ονοματεπώνυμο",
      nameTooltip:
        "Το ονοματεπώνυμο σας θα εμφανίζεται στις αιτήσεις. Μπορείτε να το επεξεργαστείτε και μετά την εγγραφή.",
      confirmPassword: "Επιβεβαίωση κωδικού πρόσβασης",
      gender: "Φύλο",
      genderPlaceholder: "Επιλέξτε φύλο",
      genderMale: "Άνδρας",
      genderFemale: "Γυναίκα",
      passwordsNoMatch: "Οι κωδικοί πρόσβασης δεν ταιριάζουν.",
      invalidEmail: "Παρακαλώ εισάγετε έγκυρο email.",
      success:
        "Η εγγραφή ολοκληρώθηκε με επιτυχία. Για να ενεργοποιήσετε όλες τις λειτουργίες, επιβεβαιώστε το email σας από το link που λάβατε και στη συνέχεια συνδεθείτε.",
      genericError:
        "Προέκυψε απρόβλεπτο σφάλμα κατά την εγγραφή. Παρακαλώ δοκιμάστε ξανά.",
      emailExists:
        "Υπάρχει ήδη λογαριασμός με αυτό το email. Χρησιμοποιήστε άλλο email ή συνδεθείτε.",
      serverError:
        "Η εγγραφή δεν ολοκληρώθηκε λόγω τεχνικού προβλήματος. Παρακαλώ δοκιμάστε ξανά σε λίγο.",
    },
    table: {
      searchPlaceholder: "Αναζήτηση...",
      clearSearch: "Καθαρισμός αναζήτησης",
      empty: "Δεν υπάρχουν διαθέσιμες εγγραφές.",
      entries: "Εμφάνιση: {visible} από {total}",
    },
    toast: {
      close: "Κλείσιμο ειδοποίησης",
    },
    upload: {
      checking: "Έλεγχος...",
      checkPdf: "Έλεγχος PDF",
      invalidType: "Μη αποδεκτός τύπος αρχείου.",
      allowedOnly: "Επιτρέπονται μόνο: {types}",
      maxSizeError: "Μέγιστο μέγεθος αρχείου: {mb}MB.",
      dropHere: "Αναρτήστε {content} εδώ",
      pickExisting: "Επιλέξτε από τα ήδη αναρτημένα αρχεία σας",
      uploadNew: "Ανέβασμα νέου αρχείου",
      dragDrop: "ή σύρετε και αφήστε",
      maxSizeHint: "Μέγιστο μέγεθος: {mb}MB",
      pdfChecking: "Γίνεται έλεγχος του PDF. Παρακαλώ περιμένετε.",
      pdfFailed: "Αποτυχία ελέγχου PDF.",
      pdfPrompt: "Πατήστε Έλεγχος PDF για να συνεχίσετε.",
      alreadyUploaded: "Το αρχείο \"{name}\" είναι ήδη αναρτημένο",
      declaration: "Η υπεύθυνη δήλωση",
      selectedSuccess: "επιλέχθηκε επιτυχώς",
      formatsHint: "PDF, DOC, DOCX, ODT · Μέγιστο μέγεθος: {mb}MB",
    },
    userMenu: {
      user: "Χρήστης",
      changePassword: "Αλλαγή κωδικού",
      logout: "Αποσύνδεση",
    },
    applicationCard: {
      firstSubmission: "Ημερομηνία 1ης υποβολής:",
      resubmission: "Ημερομηνία επανυποβολής:",
      submission: "Ημερομηνία υποβολής:",
      deadline: "Ημερομηνία λήξης αιτήσεων:",
      points: "Μόρια:",
      view: "Προβολή αίτησης",
    },
    positionSelect: {
      label: "Θέση",
      placeholder: "Αναζήτηστε με σχολή, τμήμα ή επιστημονικό πεδίο...",
      clearSelection: "Καθαρισμός επιλογής",
      noResults: "Δεν βρέθηκαν αποτελέσματα",
      showing: "Εμφάνιση {shown} από {total}",
    },
    vaultFile: {
      opening: "Ανοίγει...",
      view: "Δείτε",
      downloading: "Λήψη...",
      download: "Κατεβάστε",
      replace: "Αντικατάσταση",
      delete: "Διαγραφή",
      usedInApplication: "Το αρχείο χρησιμοποιείται σε υποβληθείσα αίτηση.",
    },
    phd: {
      title: "Διδακτορική διατριβή:",
      abstract: "Περίληψη",
      keywords: "Λέξεις-κλειδιά",
      abstractLabel: "Περίληψη διδακτορικής διατριβής",
      words: "λέξεις",
      minWords: "Ελάχιστο {min} λέξεις.",
      maxWords: "Μέγιστο {max} λέξεις.",
    },
    sections: {
      bio: {
        label: "Βιογραφικό σημείωμα",
        content: "το βιογραφικό σας",
        supportingDocs: "Εγγράφα που τεκμηριώνουν τα διαλαμβανόμενα στο βιογραφικό",
      },
      publications: {
        title: "Επιστημονικές δημοσιεύσεις",
        empty: "Δεν έχετε προσθέσει ακόμη κάποια επιστημονική δημοσίευση.",
        emptyHint: "Χρησιμοποιήστε το κουμπί παρακάτω για να προσθέσετε μία.",
        addNew: "+ Προσθήκη νέας",
      },
      workExperience: {
        years: "Χρόνια μεταδιδακτορικής εργασιακής εμπειρίας (εξαιρείται η διδακτική εμπειρία)",
        certificates: "Βεβαιώσεις προϋπηρεσίας από τον Φορέα / Συμβάσεις ως τεκμήρια μεταδιδακτορικής εργασιακής εμπειρίας (εξαιρείται η διδακτική εμπειρία)",
      },
    },
    phdSection: {
      degreeFallback: "Διδακτορικό {n}",
      titleLabel: "Τίτλος διδακτορικής διατριβής",
      titlePlaceholder: "Εισάγετε τον τίτλο της διδακτορικής διατριβής",
      clearTitle: "Καθαρισμός τίτλου",
      dateLabel: "Ημερομηνία λήψης διδακτορικού τίτλου",
      dateRange: "Επιτρεπτό εύρος: 01-01-2011 έως {today}",
      diplomaLabel: "Διδακτορικό δίπλωμα (φωτοαντίγραφο ή σκαναρισμένο αντίγραφο)",
      diplomaContent: "το διδακτορικό σας",
      abstractPlaceholder: "Γράψτε μια σύντομη περίληψη της διατριβής σας",
      removeKeyword: "Αφαίρεση λέξης-κλειδιού {keyword}",
      keywordHint: "Πληκτρολογήστε και πατήστε Enter ή κόμμα για να προσθέσετε λέξη-κλειδί.",
      clearKeywords: "Καθαρισμός λέξεων-κλειδιών",
      keywordCount: "{count}/{max} λέξεις-κλειδιά",
      keywordRange: "Επιτρέπονται {min} έως {max} λέξεις-κλειδιά.",
      foreignInstitute: "Κατοχή τίτλου από ίδρυμα του εξωτερικού (αναγνωρισμένο από τον ΔΟΑΤΑΠ)",
      doatapLabel: "Έγγραφο αναγνώρισης ΔΟΑΤΑΠ",
      doatapContent: "το έγγραφο αναγνώρισης από τον ΔΟΑΤΑΠ",
    },
    personalInfo: {
      streetAddress: "Οδός και αριθμός",
      city: "Πόλη",
      postalCode: "Ταχυδρομικός κώδικας",
      mobile: "Κινητό τηλέφωνο",
      landline: "Σταθερό τηλέφωνο",
      mobileRequired: "Το κινητό είναι υποχρεωτικό.",
      mobileInvalid: "Ο αριθμός κινητού πρέπει να έχει 10 ψηφία και να ξεκινά από 69.",
      landlineInvalid: "Ο αριθμός σταθερού πρέπει να έχει 10 ψηφία και να ξεκινά από 2.",
      postalRequired: "Ο Τ.Κ. είναι υποχρεωτικός.",
      postalInvalid: "Ο Τ.Κ. πρέπει να έχει 5 ψηφία.",
    },
    documents: {
      publicEmployee: "Είμαι δημόσιος υπάλληλος",
      publicEmployeeDoc: "Πρωτοκολλημένη αίτηση για έκδοση σχετικής άδειας από το αρμόδιο όργανο για δημοσίους υπαλλήλους",
      applicationContentLabel: "την πρωτοκολλημένη αίτηση",
      applicationContentStatus: "η αίτηση",
      euCitizen: "Είμαι πολίτης κράτους – μέλους της Ευρωπαϊκής Ένωσης (εκτός Ελλάδας)",
      greekLanguageCert: "Πιστοποιητικό ελληνομάθειας Δ΄ επιπέδου από το Κέντρο Ελληνικής Γλώσσας",
      certContentLabel: "το πιστοποιητικό",
      certContentStatus: "το πιστοποιητικό",
      notParticipated: "Δεν έχω επιλεγεί σε άλλο πρόγραμμα Απόκτησης Ακαδημαϊκής Διδακτικής Εμπειρίας, στο πλαίσιο των προηγούμενων προσκλήσεων ΕΔΒΜ 20 (ακαδ. έτος 2016‑2017), ΕΔΒΜ 45 (ακαδ. έτος 2017‑2018), ΕΔΒΜ 82 (ακαδ. έτος 2018‑2019), καθώς και της ΕΔΒΜ 96 (ακαδ. έτη 2019‑2020 και 2020‑2021) του ΕΠ ΑΝΑΔ ΕΔΒΜ 2014‑2020.",
      notParticipatedDoc: "Υπεύθυνη δήλωση μη προηγούμενης συμμετοχής",
      declarationContentLabel: "την υπεύθυνη δήλωση",
      declarationContentStatus: "η υπεύθυνη δήλωση",
      militaryDoc: "Υπεύθυνη δήλωση εκπλήρωσης στρατιωτικών υποχρεώσεων ή νόμιμης απαλλαγής από αυτές ή αναβολής για το ακαδημαϊκό έτος {year}",
      restrictionsPrefix: "Υπεύθυνη δήλωση σχετικά με τους ",
      restrictionsLink: "περιορισμούς της Πράξης",
    },
    filter: {
      title: "Φίλτρα",
      pointsLabel: "Εύρος μορίων",
      school: "Σχολή",
      department: "Τμήμα",
      scientificField: "Επιστημονικό πεδίο",
      gender: "Φύλο",
      positionStatus: "Κατάσταση θέσης",
      min: "Ελάχιστο",
      max: "Μέγιστο",
      apply: "Εφαρμογή",
      dateFrom: "{label} από",
      dateTo: "{label} έως",
    },
    publication: {
      issnInvalid: "Το ISSN που εισάγατε δεν είναι έγκυρο ή δεν βρέθηκε στη βάση δεδομένων.",
      type: "Είδος",
      typeJournal: "Δημοσίευση σε επιστημονικό περιοδικό",
      typeConference: "Δημοσίευση σε πρακτικά διεθνών συνεδρίων",
      typeOther: "Άλλες δημοσιεύσεις",
      year: "Έτος",
      workTitle: "Τίτλος εργασίας",
      publicationTitle: "Τίτλος δημοσίευσης",
      authors: "Συγγραφείς",
      category: "Κατηγορία",
      book: "Βιβλίο",
      monograph: "Μονογραφία",
      conferencePresentation: "Ανακοίνωση σε συνέδριο",
      other: "Άλλο",
      conferenceTitle: "Τίτλος συνεδρίου",
      publisher: "Εκδοτικός οίκος",
      journalTitle: "Τίτλος περιοδικού",
      issn: "ISSN περιοδικού",
    },
    publicationsDrawer: {
      header: "Επιστημονικές δημοσιεύσεις",
      issnNotFound: "Το ISSN δεν βρέθηκε",
      journalsHeading: "Δημοσιεύσεις σε επιστημονικά περιοδικά",
      conferenceHeading: "Δημοσιεύσεις σε πρακτικά διεθνών συνεδρίων",
      booksHeading: "Βιβλία/μονογραφίες",
      conferencePresentationHeading: "Ανακοίνωση σε συνέδριο",
      otherHeading: "Άλλες δημοσιεύσεις",
      authors: "Συγγραφείς",
      year: "Έτος",
      title: "Τίτλος",
      journalTitle: "Τίτλος περιοδικού",
      issn: "ISSN",
      quartile: "Quartile",
      points: "Μόρια",
      conferenceTitle: "Τίτλος συνεδρίου",
      publisher: "Εκδότης",
    },
    courses: {
      code: "Κωδικός",
      name: "Όνομα",
      description: "Περιγραφή",
      semester: "Εξάμηνο",
      teachingUnits: "Διδακτικές μονάδες",
      ects: "ECTS",
      theoryHours: "Θεωρία (Ώρες)",
      labHours: "Εργαστήριο (Ώρες)",
      category: "Κατηγορία",
      descriptionTitle: "Περιγραφή μαθήματος",
      descriptionTitleNamed: "Περιγραφή μαθήματος: {name}",
      descriptionPrefix: "Περιγραφή μαθήματος:",
      noDescription: "Δεν υπάρχει διαθέσιμη περιγραφή.",
      view: "Προβολή",
      fieldCoursesHeading: "Μαθήματα επιστημονικού πεδίου:",
      noCoursesAvailable: "Δεν υπάρχουν διαθέσιμα μαθήματα.",
      positionLabel: "Θέση ( Σχολή - Τμήμα - Επιστημονικό πεδίο )",
      positionLabelTooltip: "Το επιστημονικό πεδίο δεν αλλάζει κατά την επανυποβολή.",
      applicationsStart: "Έναρξη αιτήσεων θέσης:",
      applicationsEnd: "Λήξη αιτήσεων θέσης:",
      selectPositionToView: "Επιλέξτε θέση για να δείτε τα διαθέσιμα μαθήματα",
      coursesTitle: "Μαθήματα",
      selectFieldToView: "Επιλέξτε επιστημονικό πεδίο για να δείτε τα διαθέσιμα μαθήματα.",
      noCoursesAdded: "Δεν έχετε προσθέσει ακόμη κάποιο μάθημα.",
      addHint: "Χρησιμοποιήστε το κουμπί παρακάτω για να προσθέσετε ένα.",
      ectsError: "Τα ECTS πρέπει να είναι μεγαλύτερα από 0.",
      teachingUnitsError: "Οι διδακτικές μονάδες πρέπει να είναι μεγαλύτερες από 0.",
      theoryHoursError: "Οι ώρες θεωρίας δεν μπορούν να είναι αρνητικές.",
      labHoursError: "Οι ώρες εργαστηρίου δεν μπορούν να είναι αρνητικές.",
      hoursError: "Οι ώρες θεωρίας και εργαστηρίου δεν μπορούν να είναι ταυτόχρονα 0.",
      nameLabel: "Όνομα μαθήματος",
      codeLabel: "Κωδικός μαθήματος",
      semesterWinter: "Χειμερινό",
      semesterSpring: "Εαρινό",
      categoryMandatory: "Υποχρεωτικό",
      categoryElective: "Επιλογής",
      theoryHoursLabel: "Ώρες θεωρίας",
      labHoursLabel: "Ώρες εργαστηρίου",
      descriptionPlaceholder: "Περιγραφή μαθήματος...",
      addCourse: "+ Προσθήκη μαθήματος",
      planGeneralDescription: "Γενική περιγραφή μαθήματος",
      planLearningObjectives: "Μαθησιακοί στόχοι",
      planDeliveryMethods: "Τρόπος παράδοσης & διδακτικές μέθοδοι",
      planBibliography: "Βιβλιογραφία - Εκπαιδευτικό υλικό",
      planLearningOutcomes: "Μαθησιακά αποτελέσματα",
      planAssessment: "Μέθοδοι και κριτήρια αξιολόγησης",
      phGeneralDescription: "Συμπληρώστε γενική περιγραφή για το μάθημα...",
      phLearningObjectives: "Συμπληρώστε μαθησιακούς στόχους...",
      phDeliveryMethods: "Συμπληρώστε τρόπο παράδοσης και διδακτικές μεθόδους...",
      phBibliography: "Συμπληρώστε βιβλιογραφία και εκπαιδευτικό υλικό...",
      phLearningOutcomes: "Συμπληρώστε μαθησιακά αποτελέσματα...",
      phAssessment: "Συμπληρώστε μεθόδους και κριτήρια αξιολόγησης...",
      selectFieldFirst: "Επιλέξτε πρώτα επιστημονικό πεδίο στο προηγούμενο βήμα.",
      noCoursesForPosition: "Δεν υπάρχουν μαθήματα για την επιλεγμένη θέση.",
      fieldCourses: "Μαθήματα πεδίου:",
      totalCount: "({count} συνολικά)",
      planTooltip: "Συμπληρώστε το σχεδιάγραμμα διδασκαλίας για όλα τα μαθήματα του επιστημονικού πεδίου",
      prevTabs: "Προηγούμενες καρτέλες μαθημάτων",
      nextTabs: "Επόμενες καρτέλες μαθημάτων",
      courseFallback: "Μάθημα {n}",
      scheduleFor: "Σχεδιάγραμμα διδασκαλίας για",
      untitled: "Χωρίς τίτλο",
      courseCounter: "(Μάθημα {current}/{total})",
      scheduleTitle: "Σχεδιάγραμμα διδασκαλίας",
      coursesSummary: "{field} · {count} μαθήματα",
      weekPlaceholder: "Συμπληρώστε τι θα διδαχθεί την εβδομάδα {week}...",
      scheduleLabel: "Προγραμματισμός μαθημάτων - Διδακτέα ύλη",
      weekColumn: "ΕΒΔΟΜΑΔΑ",
      weekContentColumn: "ΥΛΗ ΕΒΔΟΜΑΔΑΣ",
    },
    home: {
      welcome: "Καλώς ήρθατε",
      loginPrompt: "Παρακαλώ συνδεθείτε για να συνεχίσετε.",
    },
    verifyEmail: {
      pageTitle: "Επιβεβαίωση ηλεκτρονικής διεύθυνσης",
      goHome: "Μετάβαση στην αρχική",
      login: "Σύνδεση",
      disabled: "Η επιβεβαίωση email είναι απενεργοποιημένη.",
      missingToken: "Λείπει το token επιβεβαίωσης.",
      success: "Η επιβεβαίωση email ολοκληρώθηκε επιτυχώς.",
      failure: "Αποτυχία επιβεβαίωσης email. Παρακαλώ ζητήστε νέο link επιβεβαίωσης.",
    },
    settings: {
      pageTitle: "Αλλαγή κωδικού πρόσβασης",
      passwordMismatch: "Οι κωδικοί πρόσβασης δεν ταιριάζουν.",
      changeSuccess: "Ο κωδικός πρόσβασης άλλαξε επιτυχώς. Παρακαλώ συνδεθείτε ξανά.",
      changeError: "Σφάλμα κατά την αλλαγή κωδικού. Παρακαλώ προσπαθήστε ξανά.",
      unverifiedNotice: "Η αλλαγή κωδικού είναι διαθέσιμη μόνο μετά την επιβεβαίωση του email σας.",
      currentPassword: "Τρέχων κωδικός πρόσβασης",
      newPassword: "Νέος κωδικός πρόσβασης",
      confirmPassword: "Επιβεβαίωση νέου κωδικού",
      saving: "Αποθήκευση...",
      changeButton: "Αλλαγή κωδικού",
    },
    myApplications: {
      userApplications: "Αιτήσεις χρήστη:",
      title: "Οι αιτήσεις μου",
      confirmDelete: "Θέλετε σίγουρα να διαγράψετε αυτή την αίτηση;",
      none: "Δεν υπάρχουν καταχωρημένες αιτήσεις.",
      noneHint: "Μόλις υποβάλετε, θα εμφανίζονται εδώ με αναλυτικές πληροφορίες.",
      active: "Ενεργές",
      completed: "Ολοκληρωμένες",
      noActive: "Δεν υπάρχουν ενεργές αιτήσεις.",
      noCompleted: "Δεν υπάρχουν ολοκληρωμένες αιτήσεις.",
    },
    homeAdmin: {
      verificationSent: "Το email επιβεβαίωσης στάλθηκε επιτυχώς.",
      verificationFailed: "Αποτυχία αποστολής email επιβεβαίωσης.",
      welcome: "Καλώς ήρθατε, διαχειριστή",
      subtitle: "Έχετε πλήρη πρόσβαση στο σύστημα διαχείρισης αιτήσεων",
      verificationNotice: "Σας έχουμε ήδη στείλει email επιβεβαίωσης στη διεύθυνση που δηλώσατε κατά την εγγραφή.\nΕλέγξτε τα εισερχόμενα και τον φάκελο ανεπιθύμητης αλληλογραφίας (spam). Αν δεν το λάβατε, ζητήστε νέα αποστολή.",
      sending: "Αποστολή...",
      resendIn: "Επανάληψη αποστολής σε {seconds}s",
      resend: "Νέα αποστολή email επιβεβαίωσης",
      fieldsTitle: "Επιστημονικά πεδία και μαθήματα",
      fieldsDesc: "Δείτε, επεξεργαστείτε ή δημιουργήστε νέα επιστημονικά πεδία και μαθήματα.",
      fieldsButton: "Διαχείριση πεδίων και μαθημάτων",
      usersTitle: "Χρήστες",
      usersDesc: "Δείτε όλους τους χρήστες του συστήματος ή δημιουργήστε νέο διαχειριστή",
      usersButton: "Διαχείριση χρηστών",
      statsTitle: "Στατιστικά",
      statsDesc: "Δείτε στατιστική ανάλυση αιτήσεων και υποψηφίων βάσει διαφόρων κριτηρίων.",
      statsButton: "Δείτε στατιστικά",
      rankingTitle: "Γενική κατάταξη",
      rankingDesc: "Δείτε τη γενική κατάταξη όλων των αιτήσεων σε όλα τα επιστημονικά πεδία.",
      rankingButton: "Δείτε κατάταξη",
    },
    registerAdmin: {
      pageTitle: "Εγγραφή διαχειριστή",
      successMessage: "Ο διαχειριστής δημιουργήθηκε με επιτυχία.",
      genericError: "Προέκυψε απρόβλεπτο σφάλμα κατά την εγγραφή διαχειριστή. Παρακαλώ δοκιμάστε ξανά.",
      emailExists: "Υπάρχει ήδη λογαριασμός με αυτό το email. Χρησιμοποιήστε άλλο email.",
      sessionExpired: "Η συνεδρία σας έληξε ή δεν είναι έγκυρη. Συνδεθείτε ξανά και δοκιμάστε ξανά.",
      noPermission: "Δεν έχετε δικαίωμα δημιουργίας νέου διαχειριστή.",
      techError: "Η εγγραφή διαχειριστή δεν ολοκληρώθηκε λόγω τεχνικού προβλήματος. Παρακαλώ δοκιμάστε ξανά σε λίγο.",
      formNotice: "Αυτή η φόρμα δημιουργεί λογαριασμό διαχειριστή με ειδικά δικαιώματα",
      submit: "Εγγραφή διαχειριστή",
      submitting: "Εγγραφή διαχειριστή...",
    },
    usersPage: {
      pageTitle: "Διαχείριση χρηστών",
      viewTitle: "Δείτε χρήστες",
      viewDesc: "Δείτε λίστα με όλους τους χρήστες του συστημάτος και τους ρόλους τους.",
      viewButton: "Προβολή λίστας",
      addTitle: "Προσθήκη διαχειριστών",
      addDesc: "Δημιουργήστε νέο λογαριασμό διαχειριστή με ειδικά δικαιώματα.",
      addButton: "Δημιουργία διαχειριστή",
    },
    usersView: {
      pageTitle: "Λίστα χρηστών",
      tabApplicants: "Αιτούντες",
      tabGuests: "Επισκέπτες",
      tabAdmins: "Διαχειριστές",
      colFirstName: "Όνομα",
      colLastName: "Επώνυμο",
      colMobile: "Κινητό",
      colLandline: "Σταθερό",
      colApplications: "Αιτήσεις",
      countApplications: "Αριθμός αιτήσεων",
      visits: "Επισκέψεις",
      visitsTooltip: "Σύνολο επισκέψεων του χρήστη στη γενική κατάταξη αιτήσεων.",
      visitsAria: "Πληροφορίες για τις επισκέψεις κατάταξης",
      genderTag: "Φύλο: {label}",
      removeFilter: "Αφαίρεση φίλτρου",
      clearAll: "Καθαρισμός όλων",
      searchPlaceholder: "Αναζήτηση χρηστών...",
      clearSearch: "Καθαρισμός αναζήτησης",
      openFilters: "Άνοιγμα φίλτρων",
      filters: "Φίλτρα",
      emptyMessage: "Δεν βρέθηκαν αποτελέσματα με βάση τα φίλτρα σας.",
      userApplications: "Αιτήσεις χρήστη: {label}",
      userFolder: "Φάκελος χρήστη: {label}",
      filterModalTitle: "Φίλτρα - {label}",
    },
    homeApplicant: {
      welcome: "Καλώς ήρθατε στο Πρόγραμμα Απόκτησης Διδακτικής Εμπειρίας",
      subtitle: "Το πρόγραμμα απευθύνεται σε νέους επιστήμονες, κατόχους διδακτορικού τίτλου, που επιθυμούν να αποκτήσουν διδακτική-ακαδημαϊκή εμπειρία.",
      submitPrompt: "Συμπληρώστε και υποβάλετε την αίτησή σας για το πρόγραμμα.",
      newApplicationPrompt: "Μπορείτε να υποβάλετε νέα αίτηση για οποιαδήποτε ενεργή θέση.",
      submissionInProgress: "Η υποβολή βρίσκεται σε εξέλιξη. Παρακαλώ περιμένετε να ολοκληρωθεί.",
      noOpenPositions: "Δεν υπάρχουν διαθέσιμες ανοιχτές θέσεις για αίτηση αυτή τη στιγμή.",
      appliedAll: "Έχετε ήδη υποβάλει αίτηση σε όλες τις διαθέσιμες θέσεις.",
      submitNewTitle: "Υποβολή νέας αίτησης",
      submitTitle: "Υποβολή αίτησης",
      createApplication: "Δημιουργία αίτησης",
      myFolderTitle: "Ο φάκελός μου",
      myFolderDesc: "Δείτε ή ενημερώστε τα στοιχεία σας, τα αρχεία και τις δημοσιεύσεις σας.",
      viewFolder: "Προβολή φακέλου",
      myApplicationsTitle: "Οι αιτήσεις μου",
      myApplicationsDesc: "Δείτε τις αιτήσεις σας και τις βαθμολογίες τους ή επεξεργαστείτε τις ενεργές αιτήσεις.",
      viewApplications: "Προβολή αιτήσεων",
    },
    landing: {
      heroTitle: "ProfRanker: Σύστημα Διαχείρισης και Αξιολόγησης Αιτήσεων για την Απόκτηση Ακαδημαϊκής Διδακτικής Εμπειρίας",
      heroP1: "Η εφαρμογή ProfRanker δημιουργήθηκε για να υποστηρίξει τη διαδικασία αξιολόγησης αιτήσεων προσωρινών διδασκόντων μέσω της αυτοματοποιημένης παραγωγής προτεινόμενων κατατάξεων των υποψηφίων με βάση ποσοτικά αλλά και ποιοτικά χαρακτηριστικά των αιτήσεών τους. Λειτουργεί τόσο ως ιστότοπος ανακοίνωσης προσκλήσεων, υποβολής αιτήσεων και ανάρτησης αποτελεσμάτων αλλά και ως μηχανισμός αξιολόγησης και παραγωγής συστάσεων κατάταξης των υποψηφίων ανά θέση.",
      heroP2: "Συγκεκριμένα, αξιοποιώντας εργαλεία AI και LLM, η πλατφόρμα υποστηρίζει αφενός την αυτοματοποιημένη ανάλυση και αξιολόγηση δεδομένων κειμένου από τις αιτήσεις των υποψηφίων, όπως τίτλος, περίληψη και λέξεις κλειδιά για τις διδακτορικές διατριβές και προτεινόμενα σχεδιαγράμματα διδασκαλίας για τα μαθήματα κάθε θέσης, και αφετέρου τον έλεγχο και την αυτοματοποιημένη βαθμολόγηση του δημοσιευμένου έργου που υποβάλλεται ως μέρος των αιτήσεων των υποψηφίων με βάση τα κριτήρια που ορίζονται στη σχετική πρόσκληση. Ως αποτελέσματα, η εφαρμογή παράγει συνολικές βαθμολογίες για όλες τις αιτήσεις που έχουν υποβληθεί βάσει των οποίων χτίζεται και ένας γενικός πίνακας κατάταξης των υποψηφίων ανά θέση/επιστημονικό πεδίο.",
      heroP3: "Ως αποτέλεσμα, η εφαρμογή παράγει συνολικές βαθμολογίες για όλες τις αιτήσεις που έχουν υποβληθεί βάσει των οποίων χτίζεται ένας γενικός πίνακας κατάταξης των αιτήσεων για όλες τις δημοσιευμένες θέσεις/επιστημονικά πεδία.",
      loginCta: "Σύνδεση στην πλατφόρμα",
      registerCta: "Δημιουργία λογαριασμού",
      cardPublishTitle: "Δημοσίευση Προσκλήσεων",
      cardPublishDesc: "Διαχείριση και δημοσιοποίηση προσκλήσεων εκδήλωσης ενδιαφέροντος για θέσεις προσωρινών διδασκόντων.",
      cardSubmitTitle: "Υποβολή Αιτήσεων",
      cardSubmitDesc: "Ηλεκτρονική καταχώρηση στοιχείων υποψηφίων και υποβολή των απαιτούμενων δικαιολογητικών ανά πρόσκληση.",
      cardEvalTitle: "Αξιολόγηση Υποψηφίων",
      cardEvalDesc: "Ποσοτική βαθμολόγηση και AI-υποβοηθούμενη ποιοτική ανάλυση επιστημονικού έργου, διδακτορικών διατριβών και διδακτικών προτάσεων.",
      cardRankTitle: "Παραγωγή Κατατάξεων",
      cardRankDesc: "Δημιουργία προτεινόμενων πινάκων κατάταξης υποψηφίων ανά θέση με βάση τεκμηριωμένα κριτήρια αξιολόγησης.",
      purposeTitle: "Σκοπός της εφαρμογής",
      purposeP1: "Η εφαρμογή σχεδιάστηκε για να υποστηρίξει το πιο απαιτητικό στάδιο της διαδικασίας επιλογής προσωρινών διδασκόντων: την αξιολόγηση των υποψηφιοτήτων. Ενώ η δημοσίευση προσκλήσεων, η υποβολή αιτήσεων και η ανακοίνωση αποτελεσμάτων πραγματοποιούνται ήδη ηλεκτρονικά, η αξιολόγηση των υποψηφίων παραμένει ιδιαίτερα απαιτητική και χρονοβόρα διαδικασία.",
      purposeP2: "Το ProfRanker επιδιώκει να μειώσει τον απαιτούμενο χρόνο επεξεργασίας αιτήσεων, να προσφέρει ενιαίο περιβάλλον διαχείρισης δεδομένων και να υποστηρίξει το διοικητικό και επιστημονικό προσωπικό μέσω εργαλείων αυτοματοποιημένης ανάλυσης και παραγωγής προτεινόμενων κατατάξεων.",
      roleCandidatesTitle: "Υποψήφιοι",
      roleCandidatesDesc: "Υποβολή και επεξεργασία αιτήσεων, πρόσβαση στις υποβεβλημένες αιτήσεις τους και τις αντίστοιχες αξιολογήσεις, πρόσβαση σε προσωπικό φάκελο για τη διαχείριση δικαιολογητικών και άλλων δεδομένων για γρήγορη και εύκολη υποβολή πολλαπλών αιτήσεων.",
      roleGuestsTitle: "Επισκέπτες",
      roleGuestsDesc: "Πρόσβαση σε δημοσιευμένα αποτελέσματα μετά το πέρας της ανοιχτής περιόδου αιτήσεων και αναβάθμιση σε ρόλο αιτούντα μετά από υποβολή αίτησης σε μια θέση.",
      roleAdminsTitle: "Διαχειριστές",
      roleAdminsDesc: "Πλήρης εποπτεία δεδομένων εφαρμογής, χρηστών, θέσεων, αξιολογήσεων, λίστας κατάταξης. Δυνατότητα καταχώρησης και δημοσίευσης προσκλήσεων, και πρόσβαση σε στατιστικά στοιχεία για τη γενική χρήση και λειτουργία της εφαρμογής.",
    },
    profile: {
      readOnlyOther: "Μόνο ανάγνωση για προφίλ άλλου χρήστη.",
      firstNameRequired: "Το όνομα είναι υποχρεωτικό.",
      lastNameRequired: "Το επώνυμο είναι υποχρεωτικό.",
      mobileInvalid: "Ο αριθμός κινητού πρέπει να έχει 10 ψηφία και να ξεκινά από 69.",
      landlineInvalid: "Ο αριθμός σταθερού πρέπει να έχει 10 ψηφία και να ξεκινά από 2.",
      postalInvalid: "Ο Τ.Κ. πρέπει να έχει 5 ψηφία.",
      checkGeneralFields: "Ελέγξτε τα πεδία στα Γενικά στοιχεία.",
      changesSaved: "Οι αλλαγές αποθηκεύτηκαν.",
      saveFailed: "Αποτυχία αποθήκευσης.",
      abstractRequired: "Η περίληψη είναι υποχρεωτική.",
      abstractMinWords: "Η περίληψη πρέπει να έχει τουλάχιστον {min} λέξεις.",
      abstractMaxWords: "Η περίληψη δεν μπορεί να ξεπερνά τις {max} λέξεις.",
      keywordsMin: "Οι λέξεις-κλειδιά πρέπει να είναι τουλάχιστον {min}.",
      keywordsMax: "Οι λέξεις-κλειδιά δεν μπορούν να είναι πάνω από {max}.",
      filesAllowed: "Επιτρέπονται μόνο αρχεία PDF, DOC, DOCX, ODT.",
      fileMaxSize: "Το αρχείο πρέπει να είναι έως {maxMb}MB.",
      fileAdded: "Το αρχείο προστέθηκε.",
      fileAddFailed: "Αποτυχία προσθήκης αρχείου.",
      fileReplaced: "Το αρχείο αντικαταστάθηκε.",
      fileReplaceFailed: "Αποτυχία αντικατάστασης αρχείου.",
      fileDeleted: "Το αρχείο διαγράφηκε.",
      fileDeleteFailed: "Αποτυχία διαγραφής αρχείου.",
      fileOpenFailed: "Αποτυχία ανοίγματος αρχείου.",
      fileDownloadFailed: "Αποτυχία λήψης αρχείου.",
      fileFallback: "Αρχείο",
      restrictionsPre: "Υπεύθυνη δήλωση σχετικά με τους ",
      restrictionsLink: "περιορισμούς της Πράξης",
      sectionCv: "Βιογραφικό σημείωμα",
      sectionBioSupporting: "Έγγραφα που τεκμηριώνουν τα διαλαμβανόμενα στο βιογραφικό",
      sectionPhd: "Διδακτορικό δίπλωμα",
      sectionDoatap: "Έγγραφο αναγνώρισης από ΔΟΑΤΑΠ",
      sectionEmploymentCerts: "Βεβαιώσεις προϋπηρεσίας από τον Φορέα",
      sectionPublicEmployeePermission: "Πρωτοκολλημένη αίτηση για έκδοση σχετικής άδειας από το αρμόδιο όργανο για δημοσίους υπαλλήλους",
      sectionEuCitizen: "Πιστοποιητικό ελληνομάθειας Δ΄ επιπέδου από το Κέντρο Ελληνικής Γλώσσας",
      sectionNotParticipated: "Υπεύθυνη δήλωση μη συμμετοχής σε άλλο πρόγραμμα Απόκτησης Ακαδημαϊκής Διδακτικής Εμπειρίας",
      sectionMilitary: "Υπεύθυνη δήλωση εκπλήρωσης στρατιωτικών υποχρεώσεων / νόμιμης απαλλαγής / αναβολής",
      sectionOther: "Άλλα",
      userFolder: "Φάκελος χρήστη:",
      myFolder: "O φακελός μου",
      tabGeneral: "Γενικά στοιχεία",
      tabAdditional: "Πρόσθετα στοιχεία",
      tabVault: "Αρχεία",
      tabPublications: "Επιστημονικές δημοσιεύσεις",
      notAffectSubmitted: "Οι αλλαγές εδώ δεν επηρεάζουν ήδη υποβληθείσες αιτήσεις. Για αλλαγές σε ενεργές αιτήσεις, επεξεργαστείτε τις από την αρχική σελίδα.",
      basicHeading: "Βασικά",
      phonesHeading: "Τηλέφωνα",
      mobileLabel: "Κινητό τηλέφωνο",
      landlineLabel: "Σταθερό τηλέφωνο",
      addressHeading: "Διεύθυνση",
      streetLabel: "Οδός και αριθμός",
      cityLabel: "Πόλη",
      postalLabel: "Τ.Κ.",
      saving: "Αποθήκευση...",
      saveChanges: "Αποθήκευση αλλαγών",
      applicantProperties: "Ιδιότητες υποψηφίου",
      checkboxNotParticipated: "Μη συμμετοχή σε προηγούμενο Πρόγραμμα Απόκτησης Ακαδημαϊκής Διδακτικής Εμπειρίας",
      checkboxPublicEmployee: "Δημόσιος υπάλληλος",
      checkboxEuCitizen: "Πολίτης Ε.Ε. (εκτός Ελλάδας)",
      phdDetails: "Στοιχεία διδακτορικού",
      prevPhdAria: "Προηγούμενο διδακτορικό",
      nextPhdAria: "Επόμενο διδακτορικό",
      phdTitleLabel: "Τίτλος διδακτορικής διατριβής",
      acquisitionDateLabel: "Ημερομηνία λήψης",
      allowedRange: "Επιτρεπτό εύρος: 01-01-2011 έως {date}",
      abstractPlaceholder: "Γράψτε μια σύντομη περίληψη της διατριβής",
      abstractLabel: "Περίληψη διδακτορικής διατριβής",
      keywordsLabel: "Λέξεις-κλειδιά",
      removeKeyword: "Αφαίρεση λέξης-κλειδιού {keyword}",
      keywordsHint: "Πληκτρολογήστε και πατήστε Enter ή κόμμα για να προσθέσετε λέξη-κλειδί.",
      clearKeywordsAria: "Καθαρισμός λέξεων-κλειδιών",
      keywordsCounter: "{count}/{max} λέξεις-κλειδιά",
      keywordsRange: "Επιτρέπονται {min} έως {max} λέξεις-κλειδιά.",
      phdForeignInstitute: "Τίτλος από ίδρυμα εξωτερικού",
      workExperienceHeading: "Εργασιακή εμπειρία",
      workExperienceLabel: "Χρόνια μεταδιδακτορικής εργασιακής εμπειρίας (εξαιρείται η διδακτική εμπειρία)",
      noDocuments: "Δεν υπάρχουν καταχωρημένα δικαιολογητικά.",
      addFile: "+ Προσθήκη",
      maxSizePrefix: "Μέγιστο μέγεθος:",
    },
    positionState: {
      pending: "Προσεχής",
      active: "Ενεργή",
      completed: "Ολοκληρωμένη",
      unpublished: "Ανενεργή",
    },
    scientificFields: {
      pageTitle: "Διαχείριση επιστημονικών πεδίων",
      viewTitle: "Προβολή επιστημονικών πεδίων",
      viewDesc: "Δείτε ή επεξεργαστείτε όλα τα επιστημονικά πεδία και τα μαθήματα τους.",
      viewButton: "Δείτε όλα τα πεδία",
      createTitle: "Δημιουργία επιστημονικού πεδίου",
      createDesc: "Δημιουργήστε νέο επιστημονικό πεδίο με τα αντίστοιχα μαθήματα.",
      createButton: "+ Νέο πεδίο",
    },
    scientificFieldsView: {
      colScientificField: "Επιστημονικό πεδίο",
      colSchool: "Σχολή",
      colDepartment: "Τμήμα",
      colState: "Κατάσταση",
      colApplicants: "Αιτήσεις",
      colStartDate: "Έναρξη",
      colEndDate: "Λήξη",
      pageTitle: "Επιστημονικά πεδία",
      tagSchool: "Σχολή: {value}",
      tagDepartment: "Τμήμα: {value}",
      tagStatus: "Κατάσταση: {value}",
      tagApplicantsMin: "Πλήθος αιτήσεων ≥ {value}",
      tagApplicantsMax: "Πλήθος αιτήσεων ≤ {value}",
      tagStartFrom: "Έναρξη από {date}",
      tagStartTo: "Έναρξη έως {date}",
      tagEndFrom: "Λήξη από {date}",
      tagEndTo: "Λήξη έως {date}",
      removeFilter: "Αφαίρεση φίλτρου",
      clearAll: "Καθαρισμός όλων",
      searchPlaceholder: "Αναζήτηση πεδίων...",
      clearSearch: "Καθαρισμός αναζήτησης",
      openFilters: "Άνοιγμα φίλτρων",
      filters: "Φίλτρα",
      pointsLabel: "Εύρος πλήθους αιτήσεων",
      filterModalTitle: "Φίλτρα πεδίων",
      dateStart: "Έναρξη",
      dateEnd: "Λήξη",
      loading: "Φόρτωση πεδίων...",
      empty: "Δεν υπάρχουν διαθέσιμες θέσεις.",
    },
    scientificFieldSingle: {
      loadError: "Αποτυχία φόρτωσης δεδομένων.",
      openPosition: "Άνοιγμα θέσης",
      closePosition: "Κλείσιμο θέσης",
      positionDisabledTooltip: "Δεν μπορείτε να κλείσετε θέση που έχει ανοίξει στους υποψήφιους.",
      deleteDisabledTooltip: "Δεν μπορείτε να διαγράψετε θέση που έχει ανοίξει στους υποψηφίους.",
      editDisabledTooltip: "Δεν μπορείτε να επεξεργαστείτε θέση που έχει ανοίξει στους υποψήφιους.",
      confirmClose: "Θέλετε σίγουρα να κλείσετε τη θέση; Η ενέργεια θα διαγράψει τη θέση.",
      positionClosed: "Η θέση έκλεισε με επιτυχία.",
      positionCloseFailed: "Αποτυχία κλεισίματος θέσης.",
      confirmDelete: "Θέλετε σίγουρα να διαγράψετε το επιστημονικό πεδίο; Η ενέργεια είναι οριστική.",
      fieldDeleted: "Το επιστημονικό πεδίο διαγράφηκε με επιτυχία.",
      fieldDeleteFailed: "Αποτυχία διαγραφής επιστημονικού πεδίου.",
      pageTitlePrefix: "Επιστημονικό πεδίο:",
      pageTitle: "Επιστημονικό πεδίο",
      fieldInfoHeading: "Στοιχεία επιστημονικού πεδίου",
      colName: "Όνομα",
      colSchool: "Σχολή",
      colDepartment: "Τμήμα",
      coursesHeading: "Μαθήματα",
      colCode: "Κωδικός",
      colCourseName: "Όνομα",
      colDescription: "Περιγραφή",
      colSemester: "Εξάμηνο",
      colUnits: "Μονάδες",
      colTheory: "Θεωρία",
      colLab: "Εργαστήριο",
      colCategory: "Κατηγορία",
      descriptionModalTitle: "Περιγραφή μαθήματος: {name}",
      descriptionModalTitleNoName: "Περιγραφή μαθήματος",
      descriptionLink: "Περιγραφή",
      noCourses: "Δεν υπάρχουν διαθέσιμα μαθήματα.",
      positionInfoHeading: "Στοιχεία θέσης",
      colStart: "Έναρξη",
      colEnd: "Λήξη",
      colStatus: "Κατάσταση",
      colApplications: "Αιτήσεις",
      viewApplicationsFor: "Δείτε αιτήσεις για {name}",
      viewApplications: "Δείτε αιτήσεις",
      edit: "Επεξεργασία",
    },
    scientificFieldsCreate: {
      progressUpdate: "Ενημέρωση πεδίου {name}",
      progressCreate: "Δημιουργία πεδίου {name}",
      positionDatesFailed: "Αποτυχία ενημέρωσης ημερομηνιών θέσης.",
      fieldUpdated: "Το επιστημονικό πεδίο ενημερώθηκε με επιτυχία!",
      fieldCreated: "Το επιστημονικό πεδίο δημιουργήθηκε με επιτυχία!",
      createFailed: "Αποτυχία δημιουργίας πεδίου. Παρακαλώ δοκιμάστε ξανά.",
      titleUpdate: "Ενημέρωση πεδίου",
      titleCreate: "Δημιουργία πεδίου",
      basicInfo: "Βασικές πληροφορίες",
      fieldNameLabel: "Όνομα επιστημονικού πεδίου",
      schoolLabel: "Σχολή",
      departmentLabel: "Τμήμα",
      positionInfo: "Στοιχεία θέσης",
      startDateLabel: "Ημερομηνία έναρξης",
      endDateLabel: "Ημερομηνία λήξης",
      startTimeLabel: "Ώρα έναρξης",
      endTimeLabel: "Ώρα λήξης",
      submittingUpdate: "Ενημέρωση...",
      submittingCreate: "Δημιουργία...",
    },
    ranking: {
      pageTitle: "Λίστα κατάταξης αιτήσεων",
      colApplicationId: "Αριθμός Αίτησης",
      colFirstName: "Όνομα",
      colLastName: "Επώνυμο",
      colSchool: "Σχολή",
      colDepartment: "Τμήμα",
      colScientificField: "Επιστημονικό πεδίο",
      colSubmitDate: "Ημερομηνία Υποβολής",
      colStatus: "Κατάσταση αιτήσεων",
      colTotalPoints: "Βαθμολόγηση (σε μόρια)",
      tagSchool: "Σχολή: {value}",
      tagDepartment: "Τμήμα: {value}",
      tagScientificField: "Επιστημονικό πεδίο: {value}",
      tagStatus: "Κατάσταση: {value}",
      tagPointsMin: "Μόρια ≥ {value}",
      tagPointsMax: "Μόρια ≤ {value}",
      tagSubmitFrom: "Ημερομηνία υποβολής από {date}",
      tagSubmitTo: "Ημερομηνία υποβολής έως {date}",
      removeFilter: "Αφαίρεση φίλτρου",
      clearAll: "Καθαρισμός όλων",
      searchPlaceholder: "Αναζήτηση αιτήσεων...",
      clearSearch: "Καθαρισμός αναζήτησης",
      openFilters: "Άνοιγμα φίλτρων",
      filters: "Φίλτρα",
      filterModalTitle: "Φίλτρα αιτήσεων",
      submitDateLabel: "Ημερομηνία υποβολής",
      showMyPositions: "Εμφάνιση αιτήσεων για τις θέσεις που έχω επιλέξει (μόνο ολοκληρωμένες)",
      empty: "Δεν βρέθηκαν αποτελέσματα με βάση τα φίλτρα σας.",
    },
    analytics: {
      pageTitle: "Στατιστικά",
      needLogin: "Απαιτείται σύνδεση ως διαχειριστής.",
      loadFailed: "Αδυναμία φόρτωσης analytics.",
      school: "Σχολή",
      department: "Τμήμα",
      allFem: "Όλες",
      allNeut: "Όλα",
      positionLabel: "Θέση",
      positionPlaceholder: "Αναζήτηση θέσης...",
      reset: "Επαναφορά",
      notDeclared: "Χωρίς δήλωση",
      statApplicants: "Αριθμός υποψηφίων",
      statTotalApplications: "Συνολικές αιτήσεις",
      statAvgPoints: "Μ.Ο. συνολικών μορίων",
      statAvgExperience: "Μ.Ο. χρόνων εμπειρίας",
      statAvgPublications: "Μ.Ο. δημοσιεύσεων ανά αίτηση",
      chartPhdYear: "Έτος λήψης διδακτορικού τίτλου",
      chartWorkExperience: "Χρόνια μεταδιδακτορικής εργασιακής εμπειρίας",
      chartScoreDistribution: "Κατανομή μορίων ανά αίτηση",
      chartRelevanceDistribution: "Κατανομή μορίων συνάφειας ανά αίτηση",
      chartPublications: "Δημοσιεύσεις ανά αίτηση",
      genderTitle: "Φύλο",
      timelineTitle: "Ρυθμός υποβολής αιτήσεων",
      noData: "Δεν υπάρχουν διαθέσιμα δεδομένα.",
      total: "Σύνολο",
      applicationSingular: "αίτηση",
      applicationPlural: "αιτήσεις",
      candidateSingular: "υποψήφιος/α",
      candidatePlural: "υποψήφιοι",
      yearsSuffix: "χρόνια",
      publicationsSuffix: "δημοσιεύσεις",
      pointsSuffix: "μόρια",
      relevancePointsSuffix: "μόρια συνάφειας",
      value: "Τιμή",
      analysisPrefix: "Ανάλυση",
      perDay: "ανά ημέρα",
      perWeek: "ανά εβδομάδα",
      perMonth: "ανά μήνα",
      perPeriod: "ανά περίοδο",
      periodSubmissions: "Υποβολές περιόδου",
      cumulativeSubmissions: "Συνολικές υποβολές",
    },
    applicationScore: {
      relevanceVeryLow: "Πολύ χαμηλή συνάφεια",
      relevanceLow: "Χαμηλή συνάφεια",
      relevanceMedium: "Μέτρια συνάφεια",
      relevanceHigh: "Υψηλή συνάφεια",
      relevanceVeryHigh: "Πολύ υψηλή συνάφεια",
      periodEndedAlert: "Η περίοδος αιτήσεων για αυτή τη θέση έχει ολοκληρωθεί. Δεν επιτρέπονται πια επεξεργασία ή διαγραφή. Η σελίδα θα ανανεωθεί.",
      confirmDelete: "Θέλετε σίγουρα να διαγράψετε αυτή την αίτηση;",
      pageTitle: "Αίτηση & Βαθμολογία",
      pageTitlePrefix: "Αίτηση & Βαθμολογία: ",
      editHintPrefix: "Μπορείτε να επεξεργαστείτε ή να διαγράψετε την αίτηση έως",
      editApplication: "Επεξεργασία αίτησης",
      deleteApplication: "Διαγραφή αίτησης",
      tabApplication: "Αίτηση",
      tabScore: "Βαθμολογία",
      positionDetailsHeading: "Στοιχεία θέσης",
      colSchool: "Σχολή",
      colDepartment: "Τμήμα",
      colScientificField: "Επιστημονικό πεδίο",
      colStart: "Έναρξη αιτήσεων",
      colEnd: "Λήξη αιτήσεων",
      colSubmit: "Υποβολή αίτησης",
      colCourses: "Μαθήματα",
      lastResubmission: "Τελευταία επανυποβολή",
      initialSubmission: "Αρχική υποβολή",
      submitDateInfoAria: "Πληροφορίες ημερομηνίας υποβολής",
      candidateDetailsHeading: "Στοιχεία υποψηφίου",
      colFirstName: "Όνομα",
      colLastName: "Επώνυμο",
      colPhdTitle: "Διδακτορικός τίτλος",
      colPhdDate: "Ημερομηνία λήψης διδακτορικού τίτλου",
      colWorkExperience: "Μεταδιδακτορική εργασιακή εμπειρία",
      colCoursePlan: "Σχεδιάγραμμα διδασκαλίας",
      yearSingular: "χρόνος",
      yearPlural: "χρόνια",
      none: "Καμία",
      view: "Προβολή",
      submittedDocsHeading: "Υποβληθέντα δικαιολογητικά",
      colDocument: "Έγγραφο",
      colFile: "Αρχείο",
      fileFallback: "Έγγραφο",
      evaluationHeading: "Αξιολόγηση αίτησης",
      aiNote: "Κριτήρια των οποίων ο υπολογισμός έγινε με χρήση εργαλείων AI/LLM",
      colCriterion: "Κριτήριο",
      colScoring: "Βαθμολόγηση",
      critCoursePlanRelevance: "Συνάφεια σχεδιαγράμματος διδασκαλίας και καινοτόμων μεθοδολογιών/θεωριών & βιβλιογραφίας με την περιγραφή του συνόλου των μαθημάτων του Επιστημονικού πεδίου",
      coursePlanRelevanceAria: "Σημείωση συνάφειας σχεδιαγράμματος διδασκαλίας",
      critStructure: "Δομή, οργάνωση, κατανομή ύλης",
      critThesisRelevance: "Συνάφεια διδακτορικής διατριβής/δημοσιευμένου έργου με το επιστημονικό πεδίο",
      thesisRelevanceAria: "Σημείωση συνάφειας διδακτορικής διατριβής",
      critWorkExperience: "Μεταδιδακτορική εργασιακή εμπειρία",
      critNotPastProgram: "Προσαύξηση κατά 20% επί της συνολικής βαθμολογίας της υποψηφιότητας, εφόσον ο υποψήφιος δεν έχει επιλεγεί σε άλλο πρόγραμμα Απόκτησης Ακαδημαϊκής Διδακτικής Εμπειρίας, στο πλαίσιο των προηγούμενων προσκλήσεων ΕΔΒΜ 20 (ακαδ. έτος 2016‑2017), ΕΔΒΜ 45 (ακαδ. έτος 2017‑2018), ΕΔΒΜ 82 (ακαδ. έτος 2018‑2019), καθώς και της ΕΔΒΜ 96 (ακαδ. έτη 2019‑2020 και 2020‑2021) του ΕΠ ΑΝΑΔ ΕΔΒΜ 2014‑2020",
      totalPoints: "Συνολικά μόρια",
      docCv: "Βιογραφικό σημείωμα",
      docBioSupporting: "Εγγραφα που τεκμηριώνουν τα διαλαμβανόμενα στο βιογραφικό",
      docCoursePlan: "Σχεδιάγραμμα διδασκαλίας",
      docPhd: "Διδακτορικό δίπλωμα",
      docDoatap: "Έγγραφο αναγνώρισης ΔΟΑΤΑΠ",
      docEmploymentCertificates: "Βεβαιώσεις προϋπηρεσίας από τον Φορέα / Συμβάσεις ως τεκμήρια μεταδιδακτορικής εργασιακής εμπειρίας (εξαιρείται η διδακτική εμπειρία)",
      docPublicEmployeePermission: "Πρωτοκολλημένη αίτηση για έκδοση σχετικής άδειας από το αρμόδιο όργανο για δημοσίους υπαλλήλους",
      docEuCitizenGreekLanguageCertificate: "Πιστοποιητικό ελληνομάθειας Δ΄ επιπέδου από το Κέντρο Ελληνικής Γλώσσας",
      docNotParticipatedDeclaration: "Υπεύθυνη δήλωση μη προηγούμενης συμμετοχής",
      docMilitary: "Υπεύθυνη δήλωση εκπλήρωσης στρατιωτικών υποχρεώσεων ή νόμιμης απαλλαγής από αυτές ή αναβολής για το ακαδημαϊκό έτος {year}",
      docResponsibleDeclaration: "Υπεύθυνη δήλωση σχετικά με τους περιορισμούς της Πράξης",
    },
    applicationForm: {
      draftLoaded: "Φορτώθηκε αποθηκευμένο πρόχειρο για τη θέση.",
      draftLoadFailed: "Αποτυχία φόρτωσης προχείρου.",
      step1Title: "Γενικά στοιχεία",
      step1Desc: "Βασικές πληροφορίες",
      step2Title: "Επιστημονικό πεδίο",
      step3Title: "Σχεδιάγραμμα διδασκαλίας",
      step4Title: "Βιογραφικό",
      step5Title: "Διδακτορικό",
      step6Title: "Επιστημονικές δημοσιεύσεις",
      step7Title: "Εργασιακή εμπειρία",
      step8Title: "Υπεύθυνες δηλώσεις",
      submitResubmit: "Επανυποβολή αίτησης",
      submitNew: "Υποβολή αίτησης",
      periodEndedEditAlert: "Η περίοδος αιτήσεων για αυτή τη θέση έχει ολοκληρωθεί. Θα επιστρέψετε στη σελίδα της αίτησης.",
      periodExpiredAlert: "Η περίοδος αίτησεων για το επιστημονικό πεδίο {field} έληξε.",
      waiting: "Σε αναμονή",
      successResubmit: "Η αίτηση επανυποβλήθηκε επιτυχώς!",
      successNew: "Η αίτηση υποβλήθηκε επιτυχώς!",
      submitFailed: "Αποτυχία υποβολής αίτησης. Παρακαλώ δοκιμάστε ξανά.",
      headerEdit: "Επεξεργασία αίτησης υποψηφιότητας",
      headerNew: "Νέα αίτηση υποψηφιότητας",
      headerGuest: "Αίτηση υποψηφιότητας",
      uploadingFiles: "Ανέβασμα αρχείων",
      countdownPrefix: "Η θέση ",
      countdownMiddle: " κλείνει σε ",
      countdownSuffix: ". Ολοκληρώστε την {action} της αίτησης εγκαίρως.",
      countdownActionResubmit: "επανυποβολή",
      countdownActionSubmit: "υποβολή",
      prev: "Προηγούμενο",
      next: "Επόμενο",
      nextTooltip: "Συμπληρώστε όλα τα υποχρεωτικά πεδία για να συνεχίσετε",
    },
    positionCreate: {
      confirm: "Από την ημερομηνία/ώρα έναρξης της θέσης και μετά δεν θα μπορείτε να την διαγράψετε ή να την επεξεργαστείτε. Θέλετε να συνεχίσετε;",
      success: "Η θέση άνοιξε με επιτυχία!",
      failed: "Αποτυχία δημιουργίας θέσης. Παρακαλώ δοκιμάστε ξανά.",
      submitting: "Υποβολή αίτησης...",
      scientificFieldLabel: "Επιστημονικό πεδίο",
      scientificFieldPlaceholder: "Αναζητήστε με σχολή, τμήμα ή επιστημονικό πεδίο...",
      school: "Σχολή",
      department: "Τμήμα",
      startDate: "Ημερομηνία έναρξης",
      endDate: "Ημερομηνία λήξης",
      startTime: "Ώρα έναρξης",
      endTime: "Ώρα λήξης",
      cancel: "Ακύρωση",
      opening: "Άνοιγμα...",
      openPosition: "Άνοιγμα θέσης",
    },
    positionValidation: {
      scientificFieldIdRequired: "Απαιτείται επιλογή επιστημονικού πεδίου.",
      startDateRequired: "Η ημερομηνία έναρξης είναι υποχρεωτική.",
      endDateRequired: "Η ημερομηνία λήξης είναι υποχρεωτική.",
      startTimeRequired: "Η ώρα έναρξης είναι υποχρεωτική.",
      endTimeRequired: "Η ώρα λήξης είναι υποχρεωτική.",
      startFuture: "Η ημερομηνία/ώρα έναρξης πρέπει να είναι μελλοντική.",
      endAfterStart: "Η ημερομηνία/ώρα λήξης πρέπει να είναι μετά την ημερομηνία/ώρα έναρξης.",
      dateTimeRange: "Η λήξη πρέπει να είναι αυστηρά μετά την έναρξη (ημερομηνία και ώρα).",
      scientificFieldRequired: "Το επιστημονικό πεδίο είναι υποχρεωτικό.",
      schoolRequired: "Η σχολή είναι υποχρεωτική.",
      departmentRequired: "Το τμήμα είναι υποχρεωτικό.",
      coursesRequired: "Πρέπει να προσθέσετε τουλάχιστον ένα μάθημα.",
      courseMissingFields: "Το μάθημα #{index} έχει κενά υποχρεωτικά πεδία.",
      courseDescription: "Η περιγραφή πρέπει να έχει τουλάχιστον 120 χαρακτήρες χωρίς κενά και 20 λέξεις.",
      courseEcts: "Τα ECTS πρέπει να είναι μεγαλύτερα από 0.",
      courseTeachingUnits: "Οι διδακτικές μονάδες πρέπει να είναι μεγαλύτερες από 0.",
      courseTheoryHours: "Οι ώρες θεωρίας δεν μπορούν να είναι αρνητικές.",
      courseLabHours: "Οι ώρες εργαστηρίου δεν μπορούν να είναι αρνητικές.",
      courseHours: "Οι ώρες θεωρίας και εργαστηρίου δεν μπορούν να είναι ταυτόχρονα 0.",
    },
  },
  en: {
    common: {
      programShort: "Teaching Experience Acquisition Programme",
      programLong: "Academic Teaching Experience Acquisition Programme",
      email: "Email",
      password: "Password",
      close: "Close",
      clear: "Clear",
      back: "Back",
      refresh: "Refresh",
      loading: "Loading...",
      select: "Select...",
      noOptions: "No options",
      showPassword: "Show password",
      hidePassword: "Hide password",
      info: "Information",
      delete: "Delete",
      today: "Today",
      serverUnreachable:
        "Could not reach the server. Please check your connection and try again.",
    },
    header: {
      title: "CANDIDACY APPLICATION FOR TEACHING STAFF, UNIVERSITY OF PATRAS {year}",
      subtitle:
        "Call for the acquisition of teaching and academic experience for early-career scientists holding a doctorate",
      switchToLight: "Switch to light mode",
      switchToDark: "Switch to dark mode",
      login: "Log in",
      register: "Register",
      roleAdmin: "Administrator",
      roleApplicantMale: "Applicant",
      roleApplicantFemale: "Applicant",
      roleGuestMale: "Guest",
      roleGuestFemale: "Guest",
    },
    login: {
      pageTitle: "Log in to the platform",
      submit: "Log in",
      noAccount: "Don't have an account? Register",
      genericError: "An error occurred during log in. Please try again.",
      invalidCredentials:
        "Your log in details are incorrect. Check your email and password and try again.",
      serverError:
        "Log in failed due to a technical problem. Please try again shortly.",
    },
    register: {
      pageTitle: "Register to the platform",
      submit: "Register",
      haveAccount: "Already have an account? Log in",
      firstName: "First name",
      lastName: "Last name",
      nameNote: "Note about your full name",
      nameTooltip:
        "Your full name will appear on your applications. You can edit it after registering as well.",
      confirmPassword: "Confirm password",
      gender: "Gender",
      genderPlaceholder: "Select gender",
      genderMale: "Male",
      genderFemale: "Female",
      passwordsNoMatch: "The passwords do not match.",
      invalidEmail: "Please enter a valid email.",
      success:
        "Registration completed successfully. To enable all features, confirm your email via the link you received and then log in.",
      genericError: "An unexpected error occurred during registration. Please try again.",
      emailExists:
        "An account with this email already exists. Use a different email or log in.",
      serverError:
        "Registration failed due to a technical problem. Please try again shortly.",
    },
    table: {
      searchPlaceholder: "Search...",
      clearSearch: "Clear search",
      empty: "No records available.",
      entries: "Showing: {visible} of {total}",
    },
    toast: {
      close: "Close notification",
    },
    upload: {
      checking: "Checking...",
      checkPdf: "Check PDF",
      invalidType: "Unsupported file type.",
      allowedOnly: "Allowed only: {types}",
      maxSizeError: "Maximum file size: {mb}MB.",
      dropHere: "Upload {content} here",
      pickExisting: "Choose from your already uploaded files",
      uploadNew: "Upload a new file",
      dragDrop: "or drag and drop",
      maxSizeHint: "Maximum size: {mb}MB",
      pdfChecking: "The PDF is being checked. Please wait.",
      pdfFailed: "PDF check failed.",
      pdfPrompt: "Press Check PDF to continue.",
      alreadyUploaded: "The file \"{name}\" is already uploaded",
      declaration: "The declaration",
      selectedSuccess: "was selected successfully",      formatsHint: "PDF, DOC, DOCX, ODT · Maximum size: {mb}MB",    },
    userMenu: {
      user: "User",
      changePassword: "Change password",
      logout: "Log out",
    },
    applicationCard: {
      firstSubmission: "First submission date:",
      resubmission: "Resubmission date:",
      submission: "Submission date:",
      deadline: "Application deadline:",
      points: "Points:",
      view: "View application",
    },
    positionSelect: {
      label: "Position",
      placeholder: "Search by school, department or scientific field...",
      clearSelection: "Clear selection",
      noResults: "No results found",
      showing: "Showing {shown} of {total}",
    },
    vaultFile: {
      opening: "Opening...",
      view: "View",
      downloading: "Downloading...",
      download: "Download",
      replace: "Replace",
      delete: "Delete",
      usedInApplication: "The file is used in a submitted application.",
    },
    phd: {
      title: "Doctoral dissertation:",
      abstract: "Abstract",
      keywords: "Keywords",
      abstractLabel: "Doctoral dissertation abstract",
      words: "words",
      minWords: "Minimum {min} words.",
      maxWords: "Maximum {max} words.",
    },
    sections: {
      bio: {
        label: "Curriculum vitae",
        content: "your CV",
        supportingDocs: "Documents supporting the contents of the CV",
      },
      publications: {
        title: "Scientific publications",
        empty: "You have not added any scientific publication yet.",
        emptyHint: "Use the button below to add one.",
        addNew: "+ Add new",
      },
      workExperience: {
        years: "Years of postdoctoral work experience (teaching experience excluded)",
        certificates: "Certificates of prior service from the employer / Contracts as evidence of postdoctoral work experience (teaching experience excluded)",
      },
    },
    phdSection: {
      degreeFallback: "Doctorate {n}",
      titleLabel: "Doctoral dissertation title",
      titlePlaceholder: "Enter the title of the doctoral dissertation",
      clearTitle: "Clear title",
      dateLabel: "Date of doctoral degree award",
      dateRange: "Permitted range: 01-01-2011 to {today}",
      diplomaLabel: "Doctoral diploma (photocopy or scanned copy)",
      diplomaContent: "your doctorate",
      abstractPlaceholder: "Write a short summary of your dissertation",
      removeKeyword: "Remove keyword {keyword}",
      keywordHint: "Type and press Enter or comma to add a keyword.",
      clearKeywords: "Clear keywords",
      keywordCount: "{count}/{max} keywords",
      keywordRange: "{min} to {max} keywords are allowed.",
      foreignInstitute: "Degree held from a foreign institution (recognised by DOATAP)",
      doatapLabel: "DOATAP recognition document",
      doatapContent: "the DOATAP recognition document",
    },
    personalInfo: {
      streetAddress: "Street and number",
      city: "City",
      postalCode: "Postal code",
      mobile: "Mobile phone",
      landline: "Landline phone",
      mobileRequired: "Mobile phone is required.",
      mobileInvalid: "The mobile number must have 10 digits and start with 69.",
      landlineInvalid: "The landline number must have 10 digits and start with 2.",
      postalRequired: "Postal code is required.",
      postalInvalid: "Postal code must have 5 digits.",
    },
    documents: {
      publicEmployee: "I am a public employee",
      publicEmployeeDoc: "Registered application for the issuance of the relevant permit by the competent authority for public employees",
      applicationContentLabel: "the registered application",
      applicationContentStatus: "the application",
      euCitizen: "I am a citizen of an EU member state (other than Greece)",
      greekLanguageCert: "Certificate of Greek language proficiency, Level D, from the Centre for the Greek Language",
      certContentLabel: "the certificate",
      certContentStatus: "the certificate",
      notParticipated: "I have not been selected in another Academic Teaching Experience Acquisition programme, in the context of the previous calls EDBM 20 (acad. year 2016-2017), EDBM 45 (acad. year 2017-2018), EDBM 82 (acad. year 2018-2019), as well as EDBM 96 (acad. years 2019-2020 and 2020-2021) of the OP HRD EDBM 2014-2020.",
      notParticipatedDoc: "Declaration of non-participation in a previous programme",
      declarationContentLabel: "the declaration",
      declarationContentStatus: "the declaration",
      militaryDoc: "Declaration of fulfilment of military obligations or lawful exemption from them or deferment for the academic year {year}",
      restrictionsPrefix: "Declaration regarding the ",
      restrictionsLink: "restrictions of the Act",
    },
    filter: {
      title: "Filters",
      pointsLabel: "Points range",
      school: "School",
      department: "Department",
      scientificField: "Scientific field",
      gender: "Gender",
      positionStatus: "Position status",
      min: "Minimum",
      max: "Maximum",
      apply: "Apply",
      dateFrom: "{label} from",
      dateTo: "{label} to",
    },
    publication: {
      issnInvalid: "The ISSN you entered is not valid or was not found in the database.",
      type: "Type",
      typeJournal: "Publication in a scientific journal",
      typeConference: "Publication in international conference proceedings",
      typeOther: "Other publications",
      year: "Year",
      workTitle: "Work title",
      publicationTitle: "Publication title",
      authors: "Authors",
      category: "Category",
      book: "Book",
      monograph: "Monograph",
      conferencePresentation: "Conference presentation",
      other: "Other",
      conferenceTitle: "Conference title",
      publisher: "Publisher",
      journalTitle: "Journal title",
      issn: "Journal ISSN",
    },
    publicationsDrawer: {
      header: "Scientific publications",
      issnNotFound: "ISSN not found",
      journalsHeading: "Publications in scientific journals",
      conferenceHeading: "Publications in international conference proceedings",
      booksHeading: "Books/monographs",
      conferencePresentationHeading: "Conference presentation",
      otherHeading: "Other publications",
      authors: "Authors",
      year: "Year",
      title: "Title",
      journalTitle: "Journal title",
      issn: "ISSN",
      quartile: "Quartile",
      points: "Points",
      conferenceTitle: "Conference title",
      publisher: "Publisher",
    },
    courses: {
      code: "Code",
      name: "Name",
      description: "Description",
      semester: "Semester",
      teachingUnits: "Teaching units",
      ects: "ECTS",
      theoryHours: "Theory (Hours)",
      labHours: "Lab (Hours)",
      category: "Category",
      descriptionTitle: "Course description",
      descriptionTitleNamed: "Course description: {name}",
      descriptionPrefix: "Course description:",
      noDescription: "No description available.",
      view: "View",
      fieldCoursesHeading: "Scientific field courses:",
      noCoursesAvailable: "No courses available.",
      positionLabel: "Position ( School - Department - Scientific field )",
      positionLabelTooltip: "The scientific field does not change upon resubmission.",
      applicationsStart: "Position applications start:",
      applicationsEnd: "Position applications end:",
      selectPositionToView: "Select a position to view the available courses",
      coursesTitle: "Courses",
      selectFieldToView: "Select a scientific field to view the available courses.",
      noCoursesAdded: "You have not added any course yet.",
      addHint: "Use the button below to add one.",
      ectsError: "ECTS must be greater than 0.",
      teachingUnitsError: "Teaching units must be greater than 0.",
      theoryHoursError: "Theory hours cannot be negative.",
      labHoursError: "Lab hours cannot be negative.",
      hoursError: "Theory and lab hours cannot both be 0.",
      nameLabel: "Course name",
      codeLabel: "Course code",
      semesterWinter: "Winter",
      semesterSpring: "Spring",
      categoryMandatory: "Mandatory",
      categoryElective: "Elective",
      theoryHoursLabel: "Theory hours",
      labHoursLabel: "Lab hours",
      descriptionPlaceholder: "Course description...",
      addCourse: "+ Add course",
      planGeneralDescription: "General course description",
      planLearningObjectives: "Learning objectives",
      planDeliveryMethods: "Delivery method & teaching methods",
      planBibliography: "Bibliography - Educational material",
      planLearningOutcomes: "Learning outcomes",
      planAssessment: "Assessment methods and criteria",
      phGeneralDescription: "Fill in a general description for the course...",
      phLearningObjectives: "Fill in learning objectives...",
      phDeliveryMethods: "Fill in delivery method and teaching methods...",
      phBibliography: "Fill in bibliography and educational material...",
      phLearningOutcomes: "Fill in learning outcomes...",
      phAssessment: "Fill in assessment methods and criteria...",
      selectFieldFirst: "First select a scientific field in the previous step.",
      noCoursesForPosition: "There are no courses for the selected position.",
      fieldCourses: "Field courses:",
      totalCount: "({count} total)",
      planTooltip: "Fill in the teaching outline for all courses of the scientific field",
      prevTabs: "Previous course tabs",
      nextTabs: "Next course tabs",
      courseFallback: "Course {n}",
      scheduleFor: "Teaching outline for",
      untitled: "Untitled",
      courseCounter: "(Course {current}/{total})",
      scheduleTitle: "Teaching outline",
      coursesSummary: "{field} · {count} courses",
      weekPlaceholder: "Fill in what will be taught in week {week}...",
      scheduleLabel: "Course planning - Syllabus",
      weekColumn: "WEEK",
      weekContentColumn: "WEEK CONTENT",
    },
    home: {
      welcome: "Welcome",
      loginPrompt: "Please log in to continue.",
    },
    verifyEmail: {
      pageTitle: "Email address verification",
      goHome: "Go to home",
      login: "Log in",
      disabled: "Email verification is disabled.",
      missingToken: "The verification token is missing.",
      success: "Email verification completed successfully.",
      failure: "Email verification failed. Please request a new verification link.",
    },
    settings: {
      pageTitle: "Change password",
      passwordMismatch: "The passwords do not match.",
      changeSuccess: "Password changed successfully. Please log in again.",
      changeError: "Error changing the password. Please try again.",
      unverifiedNotice: "Password change is available only after verifying your email.",
      currentPassword: "Current password",
      newPassword: "New password",
      confirmPassword: "Confirm new password",
      saving: "Saving...",
      changeButton: "Change password",
    },
    myApplications: {
      userApplications: "User applications:",
      title: "My applications",
      confirmDelete: "Are you sure you want to delete this application?",
      none: "There are no submitted applications.",
      noneHint: "Once you submit, they will appear here with detailed information.",
      active: "Active",
      completed: "Completed",
      noActive: "There are no active applications.",
      noCompleted: "There are no completed applications.",
    },
    homeAdmin: {
      verificationSent: "The verification email was sent successfully.",
      verificationFailed: "Failed to send the verification email.",
      welcome: "Welcome, administrator",
      subtitle: "You have full access to the application management system",
      verificationNotice: "We have already sent a verification email to the address you provided during registration.\nCheck your inbox and your spam folder. If you did not receive it, request a new one.",
      sending: "Sending...",
      resendIn: "Resend in {seconds}s",
      resend: "Resend verification email",
      fieldsTitle: "Scientific fields and courses",
      fieldsDesc: "View, edit or create new scientific fields and courses.",
      fieldsButton: "Manage fields and courses",
      usersTitle: "Users",
      usersDesc: "View all system users or create a new administrator",
      usersButton: "Manage users",
      statsTitle: "Statistics",
      statsDesc: "View statistical analysis of applications and candidates based on various criteria.",
      statsButton: "View statistics",
      rankingTitle: "General ranking",
      rankingDesc: "View the general ranking of all applications across all scientific fields.",
      rankingButton: "View ranking",
    },
    registerAdmin: {
      pageTitle: "Register administrator",
      successMessage: "The administrator was created successfully.",
      genericError: "An unexpected error occurred while registering the administrator. Please try again.",
      emailExists: "An account with this email already exists. Please use a different email.",
      sessionExpired: "Your session has expired or is invalid. Please log in again and try again.",
      noPermission: "You do not have permission to create a new administrator.",
      techError: "Administrator registration did not complete due to a technical problem. Please try again shortly.",
      formNotice: "This form creates an administrator account with special privileges",
      submit: "Register administrator",
      submitting: "Registering administrator...",
    },
    usersPage: {
      pageTitle: "User management",
      viewTitle: "View users",
      viewDesc: "View a list of all system users and their roles.",
      viewButton: "View list",
      addTitle: "Add administrators",
      addDesc: "Create a new administrator account with special privileges.",
      addButton: "Create administrator",
    },
    usersView: {
      pageTitle: "User list",
      tabApplicants: "Applicants",
      tabGuests: "Visitors",
      tabAdmins: "Administrators",
      colFirstName: "First name",
      colLastName: "Last name",
      colMobile: "Mobile",
      colLandline: "Landline",
      colApplications: "Applications",
      countApplications: "Number of applications",
      visits: "Visits",
      visitsTooltip: "Total visits of the user to the general application ranking.",
      visitsAria: "Information about ranking visits",
      genderTag: "Gender: {label}",
      removeFilter: "Remove filter",
      clearAll: "Clear all",
      searchPlaceholder: "Search users...",
      clearSearch: "Clear search",
      openFilters: "Open filters",
      filters: "Filters",
      emptyMessage: "No results found matching your filters.",
      userApplications: "User applications: {label}",
      userFolder: "User folder: {label}",
      filterModalTitle: "Filters - {label}",
    },
    homeApplicant: {
      welcome: "Welcome to the Teaching Experience Acquisition Program",
      subtitle: "The program is aimed at young scientists holding a doctoral degree who wish to gain teaching and academic experience.",
      submitPrompt: "Fill in and submit your application for the program.",
      newApplicationPrompt: "You can submit a new application for any active position.",
      submissionInProgress: "Submission is in progress. Please wait for it to complete.",
      noOpenPositions: "There are no open positions available for application at this time.",
      appliedAll: "You have already applied to all available positions.",
      submitNewTitle: "Submit a new application",
      submitTitle: "Submit application",
      createApplication: "Create application",
      myFolderTitle: "My folder",
      myFolderDesc: "View or update your details, files and publications.",
      viewFolder: "View folder",
      myApplicationsTitle: "My applications",
      myApplicationsDesc: "View your applications and their scores, or edit your active applications.",
      viewApplications: "View applications",
    },
    landing: {
      heroTitle: "ProfRanker: Application Management and Evaluation System for Acquiring Academic Teaching Experience",
      heroP1: "The ProfRanker application was created to support the evaluation of applications from temporary teaching staff through the automated generation of suggested candidate rankings based on both quantitative and qualitative characteristics of their applications. It works both as a website for announcing calls, submitting applications and posting results, and as a mechanism for evaluating and generating ranking recommendations for candidates per position.",
      heroP2: "Specifically, by leveraging AI and LLM tools, the platform supports both the automated analysis and evaluation of text data from candidates' applications, such as the title, abstract and keywords of doctoral theses and proposed teaching outlines for the courses of each position, and the review and automated scoring of the published work submitted as part of the candidates' applications based on the criteria defined in the relevant call. As a result, the application produces overall scores for all submitted applications, on which a general ranking table of candidates per position/scientific field is built.",
      heroP3: "As a result, the application produces overall scores for all submitted applications, on which a general ranking table of applications is built for all published positions/scientific fields.",
      loginCta: "Log in to the platform",
      registerCta: "Create an account",
      cardPublishTitle: "Publishing Calls",
      cardPublishDesc: "Management and publication of calls for expressions of interest for temporary teaching positions.",
      cardSubmitTitle: "Submitting Applications",
      cardSubmitDesc: "Electronic entry of candidate details and submission of the required supporting documents per call.",
      cardEvalTitle: "Evaluating Candidates",
      cardEvalDesc: "Quantitative scoring and AI-assisted qualitative analysis of scientific work, doctoral theses and teaching proposals.",
      cardRankTitle: "Generating Rankings",
      cardRankDesc: "Creation of suggested candidate ranking tables per position based on documented evaluation criteria.",
      purposeTitle: "Purpose of the application",
      purposeP1: "The application was designed to support the most demanding stage of the temporary teaching staff selection process: the evaluation of candidacies. While publishing calls, submitting applications and announcing results are already carried out electronically, evaluating candidates remains a particularly demanding and time-consuming process.",
      purposeP2: "ProfRanker aims to reduce the time required to process applications, to offer a unified data management environment, and to support administrative and scientific staff through tools for automated analysis and the generation of suggested rankings.",
      roleCandidatesTitle: "Candidates",
      roleCandidatesDesc: "Submitting and editing applications, accessing their submitted applications and the corresponding evaluations, accessing a personal folder for managing supporting documents and other data for quick and easy submission of multiple applications.",
      roleGuestsTitle: "Visitors",
      roleGuestsDesc: "Access to published results after the end of the open application period and upgrade to applicant role after submitting an application for a position.",
      roleAdminsTitle: "Administrators",
      roleAdminsDesc: "Full oversight of application data, users, positions, evaluations and the ranking list. The ability to register and publish calls, and access to statistics on the general use and operation of the application.",
    },
    profile: {
      readOnlyOther: "Read-only for another user's profile.",
      firstNameRequired: "First name is required.",
      lastNameRequired: "Last name is required.",
      mobileInvalid: "The mobile number must have 10 digits and start with 69.",
      landlineInvalid: "The landline number must have 10 digits and start with 2.",
      postalInvalid: "The postal code must have 5 digits.",
      checkGeneralFields: "Check the fields in General information.",
      changesSaved: "Changes saved.",
      saveFailed: "Save failed.",
      abstractRequired: "The abstract is required.",
      abstractMinWords: "The abstract must have at least {min} words.",
      abstractMaxWords: "The abstract cannot exceed {max} words.",
      keywordsMin: "There must be at least {min} keywords.",
      keywordsMax: "There cannot be more than {max} keywords.",
      filesAllowed: "Only PDF, DOC, DOCX, ODT files are allowed.",
      fileMaxSize: "The file must be up to {maxMb}MB.",
      fileAdded: "File added.",
      fileAddFailed: "Failed to add file.",
      fileReplaced: "File replaced.",
      fileReplaceFailed: "Failed to replace file.",
      fileDeleted: "File deleted.",
      fileDeleteFailed: "Failed to delete file.",
      fileOpenFailed: "Failed to open file.",
      fileDownloadFailed: "Failed to download file.",
      fileFallback: "File",
      restrictionsPre: "Responsible declaration regarding the ",
      restrictionsLink: "restrictions of the Act",
      sectionCv: "Curriculum vitae",
      sectionBioSupporting: "Documents substantiating the contents of the CV",
      sectionPhd: "Doctoral diploma",
      sectionDoatap: "Recognition document from DOATAP",
      sectionEmploymentCerts: "Prior service certificates from the employer",
      sectionPublicEmployeePermission: "Registered application for issuing the relevant permit from the competent body for public employees",
      sectionEuCitizen: "Certificate of Greek language proficiency level D from the Centre for the Greek Language",
      sectionNotParticipated: "Responsible declaration of non-participation in another Academic Teaching Experience Acquisition program",
      sectionMilitary: "Responsible declaration of fulfilment of military obligations / lawful exemption / deferral",
      sectionOther: "Other",
      userFolder: "User folder:",
      myFolder: "My folder",
      tabGeneral: "General information",
      tabAdditional: "Additional information",
      tabVault: "Files",
      tabPublications: "Scientific publications",
      notAffectSubmitted: "Changes here do not affect already submitted applications. To change active applications, edit them from the home page.",
      basicHeading: "Basic",
      phonesHeading: "Phones",
      mobileLabel: "Mobile phone",
      landlineLabel: "Landline phone",
      addressHeading: "Address",
      streetLabel: "Street and number",
      cityLabel: "City",
      postalLabel: "Postal code",
      saving: "Saving...",
      saveChanges: "Save changes",
      applicantProperties: "Applicant properties",
      checkboxNotParticipated: "Non-participation in a previous Academic Teaching Experience Acquisition Program",
      checkboxPublicEmployee: "Public employee",
      checkboxEuCitizen: "EU citizen (outside Greece)",
      phdDetails: "Doctorate details",
      prevPhdAria: "Previous doctorate",
      nextPhdAria: "Next doctorate",
      phdTitleLabel: "Doctoral thesis title",
      acquisitionDateLabel: "Acquisition date",
      allowedRange: "Allowed range: 01-01-2011 to {date}",
      abstractPlaceholder: "Write a short abstract of the thesis",
      abstractLabel: "Doctoral thesis abstract",
      keywordsLabel: "Keywords",
      removeKeyword: "Remove keyword {keyword}",
      keywordsHint: "Type and press Enter or comma to add a keyword.",
      clearKeywordsAria: "Clear keywords",
      keywordsCounter: "{count}/{max} keywords",
      keywordsRange: "Between {min} and {max} keywords are allowed.",
      phdForeignInstitute: "Title from a foreign institution",
      workExperienceHeading: "Work experience",
      workExperienceLabel: "Years of postdoctoral work experience (teaching experience excluded)",
      noDocuments: "There are no registered supporting documents.",
      addFile: "+ Add",
      maxSizePrefix: "Maximum size:",
    },
    positionState: {
      pending: "Upcoming",
      active: "Active",
      completed: "Completed",
      unpublished: "Inactive",
    },
    scientificFields: {
      pageTitle: "Manage scientific fields",
      viewTitle: "View scientific fields",
      viewDesc: "View or edit all scientific fields and their courses.",
      viewButton: "View all fields",
      createTitle: "Create scientific field",
      createDesc: "Create a new scientific field with its courses.",
      createButton: "+ New field",
    },
    scientificFieldsView: {
      colScientificField: "Scientific field",
      colSchool: "School",
      colDepartment: "Department",
      colState: "Status",
      colApplicants: "Applications",
      colStartDate: "Start",
      colEndDate: "End",
      pageTitle: "Scientific fields",
      tagSchool: "School: {value}",
      tagDepartment: "Department: {value}",
      tagStatus: "Status: {value}",
      tagApplicantsMin: "Applications count ≥ {value}",
      tagApplicantsMax: "Applications count ≤ {value}",
      tagStartFrom: "Start from {date}",
      tagStartTo: "Start until {date}",
      tagEndFrom: "End from {date}",
      tagEndTo: "End until {date}",
      removeFilter: "Remove filter",
      clearAll: "Clear all",
      searchPlaceholder: "Search fields...",
      clearSearch: "Clear search",
      openFilters: "Open filters",
      filters: "Filters",
      pointsLabel: "Applications count range",
      filterModalTitle: "Field filters",
      dateStart: "Start",
      dateEnd: "End",
      loading: "Loading fields...",
      empty: "There are no available positions.",
    },
    scientificFieldSingle: {
      loadError: "Failed to load data.",
      openPosition: "Open position",
      closePosition: "Close position",
      positionDisabledTooltip: "You cannot close a position that has been opened to candidates.",
      deleteDisabledTooltip: "You cannot delete a position that has been opened to candidates.",
      editDisabledTooltip: "You cannot edit a position that has been opened to candidates.",
      confirmClose: "Are you sure you want to close the position? The action will delete the position.",
      positionClosed: "The position was closed successfully.",
      positionCloseFailed: "Failed to close position.",
      confirmDelete: "Are you sure you want to delete the scientific field? The action is permanent.",
      fieldDeleted: "The scientific field was deleted successfully.",
      fieldDeleteFailed: "Failed to delete scientific field.",
      pageTitlePrefix: "Scientific field:",
      pageTitle: "Scientific field",
      fieldInfoHeading: "Scientific field details",
      colName: "Name",
      colSchool: "School",
      colDepartment: "Department",
      coursesHeading: "Courses",
      colCode: "Code",
      colCourseName: "Name",
      colDescription: "Description",
      colSemester: "Semester",
      colUnits: "Units",
      colTheory: "Theory",
      colLab: "Lab",
      colCategory: "Category",
      descriptionModalTitle: "Course description: {name}",
      descriptionModalTitleNoName: "Course description",
      descriptionLink: "Description",
      noCourses: "There are no available courses.",
      positionInfoHeading: "Position details",
      colStart: "Start",
      colEnd: "End",
      colStatus: "Status",
      colApplications: "Applications",
      viewApplicationsFor: "View applications for {name}",
      viewApplications: "View applications",
      edit: "Edit",
    },
    scientificFieldsCreate: {
      progressUpdate: "Updating field {name}",
      progressCreate: "Creating field {name}",
      positionDatesFailed: "Failed to update position dates.",
      fieldUpdated: "The scientific field was updated successfully!",
      fieldCreated: "The scientific field was created successfully!",
      createFailed: "Failed to create field. Please try again.",
      titleUpdate: "Update field",
      titleCreate: "Create field",
      basicInfo: "Basic information",
      fieldNameLabel: "Scientific field name",
      schoolLabel: "School",
      departmentLabel: "Department",
      positionInfo: "Position details",
      startDateLabel: "Start date",
      endDateLabel: "End date",
      startTimeLabel: "Start time",
      endTimeLabel: "End time",
      submittingUpdate: "Updating...",
      submittingCreate: "Creating...",
    },
    ranking: {
      pageTitle: "Application ranking list",
      colApplicationId: "Application number",
      colFirstName: "First name",
      colLastName: "Last name",
      colSchool: "School",
      colDepartment: "Department",
      colScientificField: "Scientific field",
      colSubmitDate: "Submission date",
      colStatus: "Application status",
      colTotalPoints: "Score (in points)",
      tagSchool: "School: {value}",
      tagDepartment: "Department: {value}",
      tagScientificField: "Scientific field: {value}",
      tagStatus: "Status: {value}",
      tagPointsMin: "Points ≥ {value}",
      tagPointsMax: "Points ≤ {value}",
      tagSubmitFrom: "Submission date from {date}",
      tagSubmitTo: "Submission date until {date}",
      removeFilter: "Remove filter",
      clearAll: "Clear all",
      searchPlaceholder: "Search applications...",
      clearSearch: "Clear search",
      openFilters: "Open filters",
      filters: "Filters",
      filterModalTitle: "Application filters",
      submitDateLabel: "Submission date",
      showMyPositions: "Show applications for the positions I've applied for (completed only)",
      empty: "No results found based on your filters.",
    },
    analytics: {
      pageTitle: "Statistics",
      needLogin: "Administrator login required.",
      loadFailed: "Failed to load analytics.",
      school: "School",
      department: "Department",
      allFem: "All",
      allNeut: "All",
      positionLabel: "Position",
      positionPlaceholder: "Search position...",
      reset: "Reset",
      notDeclared: "Not declared",
      statApplicants: "Number of candidates",
      statTotalApplications: "Total applications",
      statAvgPoints: "Avg. total points",
      statAvgExperience: "Avg. years of experience",
      statAvgPublications: "Avg. publications per application",
      chartPhdYear: "PhD title acquisition year",
      chartWorkExperience: "Years of post-doctoral work experience",
      chartScoreDistribution: "Points distribution per application",
      chartRelevanceDistribution: "Relevance points distribution per application",
      chartPublications: "Publications per application",
      genderTitle: "Gender",
      timelineTitle: "Application submission rate",
      noData: "No data available.",
      total: "Total",
      applicationSingular: "application",
      applicationPlural: "applications",
      candidateSingular: "candidate",
      candidatePlural: "candidates",
      yearsSuffix: "years",
      publicationsSuffix: "publications",
      pointsSuffix: "points",
      relevancePointsSuffix: "relevance points",
      value: "Value",
      analysisPrefix: "Analysis",
      perDay: "per day",
      perWeek: "per week",
      perMonth: "per month",
      perPeriod: "per period",
      periodSubmissions: "Period submissions",
      cumulativeSubmissions: "Cumulative submissions",
    },
    applicationScore: {
      relevanceVeryLow: "Very low relevance",
      relevanceLow: "Low relevance",
      relevanceMedium: "Medium relevance",
      relevanceHigh: "High relevance",
      relevanceVeryHigh: "Very high relevance",
      periodEndedAlert: "The application period for this position has ended. Editing or deletion is no longer allowed. The page will reload.",
      confirmDelete: "Are you sure you want to delete this application?",
      pageTitle: "Application & Score",
      pageTitlePrefix: "Application & Score: ",
      editHintPrefix: "You can edit or delete the application until",
      editApplication: "Edit application",
      deleteApplication: "Delete application",
      tabApplication: "Application",
      tabScore: "Score",
      positionDetailsHeading: "Position details",
      colSchool: "School",
      colDepartment: "Department",
      colScientificField: "Scientific field",
      colStart: "Applications start",
      colEnd: "Applications end",
      colSubmit: "Application submission",
      colCourses: "Courses",
      lastResubmission: "Last resubmission",
      initialSubmission: "Initial submission",
      submitDateInfoAria: "Submission date information",
      candidateDetailsHeading: "Candidate details",
      colFirstName: "First name",
      colLastName: "Last name",
      colPhdTitle: "PhD title",
      colPhdDate: "PhD title acquisition date",
      colWorkExperience: "Post-doctoral work experience",
      colCoursePlan: "Teaching plan",
      yearSingular: "year",
      yearPlural: "years",
      none: "None",
      view: "View",
      submittedDocsHeading: "Submitted documents",
      colDocument: "Document",
      colFile: "File",
      fileFallback: "Document",
      evaluationHeading: "Application evaluation",
      aiNote: "Criteria calculated using AI/LLM tools",
      colCriterion: "Criterion",
      colScoring: "Scoring",
      critCoursePlanRelevance: "Relevance of the teaching plan and innovative methodologies/theories & bibliography to the description of all courses of the Scientific field",
      coursePlanRelevanceAria: "Teaching plan relevance note",
      critStructure: "Structure, organization, content distribution",
      critThesisRelevance: "Relevance of the doctoral thesis/published work to the scientific field",
      thesisRelevanceAria: "Doctoral thesis relevance note",
      critWorkExperience: "Post-doctoral work experience",
      critNotPastProgram: "20% increase on the total score of the candidacy, provided the candidate has not been selected in another Academic Teaching Experience Acquisition program, within the framework of the previous calls EDVM 20 (acad. year 2016‑2017), EDVM 45 (acad. year 2017‑2018), EDVM 82 (acad. year 2018‑2019), as well as EDVM 96 (acad. years 2019‑2020 and 2020‑2021) of the OP HRD EDVM 2014‑2020",
      totalPoints: "Total points",
      docCv: "Curriculum vitae",
      docBioSupporting: "Documents supporting the claims in the CV",
      docCoursePlan: "Teaching plan",
      docPhd: "Doctoral diploma",
      docDoatap: "DOATAP recognition document",
      docEmploymentCertificates: "Employment certificates from the institution / Contracts as evidence of post-doctoral work experience (teaching experience excluded)",
      docPublicEmployeePermission: "Registered application for the issuance of a relevant permit from the competent body for public employees",
      docEuCitizenGreekLanguageCertificate: "Level D Greek language proficiency certificate from the Centre for the Greek Language",
      docNotParticipatedDeclaration: "Declaration of no previous participation",
      docMilitary: "Declaration of fulfillment of military obligations or legal exemption from them or deferral for academic year {year}",
      docResponsibleDeclaration: "Declaration regarding the restrictions of the Act",
    },
    applicationForm: {
      draftLoaded: "Loaded a saved draft for this position.",
      draftLoadFailed: "Failed to load draft.",
      step1Title: "General information",
      step1Desc: "Basic information",
      step2Title: "Scientific field",
      step3Title: "Teaching plan",
      step4Title: "CV",
      step5Title: "Doctorate",
      step6Title: "Scientific publications",
      step7Title: "Work experience",
      step8Title: "Declarations",
      submitResubmit: "Resubmit application",
      submitNew: "Submit application",
      periodEndedEditAlert: "The application period for this position has ended. You will return to the application page.",
      periodExpiredAlert: "The application period for the scientific field {field} has ended.",
      waiting: "Waiting",
      successResubmit: "The application was resubmitted successfully!",
      successNew: "The application was submitted successfully!",
      submitFailed: "Application submission failed. Please try again.",
      headerEdit: "Edit candidacy application",
      headerNew: "New candidacy application",
      headerGuest: "Candidacy application",
      uploadingFiles: "Uploading files",
      countdownPrefix: "The position ",
      countdownMiddle: " closes in ",
      countdownSuffix: ". Complete the application {action} in time.",
      countdownActionResubmit: "resubmission",
      countdownActionSubmit: "submission",
      prev: "Previous",
      next: "Next",
      nextTooltip: "Fill in all required fields to continue",
    },
    positionCreate: {
      confirm: "From the position's start date/time onwards you will no longer be able to delete or edit it. Do you want to continue?",
      success: "The position was opened successfully!",
      failed: "Failed to create the position. Please try again.",
      submitting: "Submitting application...",
      scientificFieldLabel: "Scientific field",
      scientificFieldPlaceholder: "Search by school, department or scientific field...",
      school: "School",
      department: "Department",
      startDate: "Start date",
      endDate: "End date",
      startTime: "Start time",
      endTime: "End time",
      cancel: "Cancel",
      opening: "Opening...",
      openPosition: "Open position",
    },
    positionValidation: {
      scientificFieldIdRequired: "A scientific field selection is required.",
      startDateRequired: "The start date is required.",
      endDateRequired: "The end date is required.",
      startTimeRequired: "The start time is required.",
      endTimeRequired: "The end time is required.",
      startFuture: "The start date/time must be in the future.",
      endAfterStart: "The end date/time must be after the start date/time.",
      dateTimeRange: "The end must be strictly after the start (date and time).",
      scientificFieldRequired: "The scientific field is required.",
      schoolRequired: "The school is required.",
      departmentRequired: "The department is required.",
      coursesRequired: "You must add at least one course.",
      courseMissingFields: "Course #{index} has empty required fields.",
      courseDescription: "The description must have at least 120 characters without spaces and 20 words.",
      courseEcts: "ECTS must be greater than 0.",
      courseTeachingUnits: "Teaching units must be greater than 0.",
      courseTheoryHours: "Theory hours cannot be negative.",
      courseLabHours: "Lab hours cannot be negative.",
      courseHours: "Theory and lab hours cannot both be 0 at the same time.",
    },
  },
};

export default translations;
